import { css, LitElement, html } from "lit";
import { property } from "lit/decorators.js";
import { unsafeSVG } from "lit/directives/unsafe-svg.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const ICON_SIZES = [
  "10",
  "12",
  "16",
  "18",
  "20",
  "24",
  "32",
  "48"
];
const DEFAULT_ICON_SIZE = "18";
class SvgIconElement extends LitElement {
  constructor() {
    super(...arguments);
    this.size = DEFAULT_ICON_SIZE;
  }
  renderIcon({ template, viewBox }) {
    const svgSize = ICON_SIZES.includes(this.size) ? this.size : DEFAULT_ICON_SIZE;
    const viewBoxAttribute = viewBox.join(" ");
    return html`<svg xmlns="http://www.w3.org/2000/svg" viewBox="${viewBoxAttribute}" height="${svgSize}" width="${svgSize}">${unsafeSVG(template)}</svg>`;
  }
}
SvgIconElement.styles = css`:host{display:inline-flex}svg>path{fill:currentColor}`;
__decorateClass([
  property({ reflect: true })
], SvgIconElement.prototype, "size", 2);
export { DEFAULT_ICON_SIZE, ICON_SIZES, SvgIconElement };
